export enum EmployeeIdentifierTypes
{
  PhoneNumber = 1,
  EmployeeID=2
}
